import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import Linkify from 'react-linkify';
import Anchor from '../Anchor/Anchor';
import './CommentText.css';
import { createCommentChunkArray } from '../../utils/mentioning/mentionFormatters';
import Truncate from '../Truncate/Truncate';
import { COMMENTS_CONTEXT_SOCIAL_FEED } from '../../utils/constants/commentConstants';
import { getCommentsContext } from '../../store/selectors/settings/settingsSelectors';

const componentDecorator = (href, text, key) => (
  <span styleName="comment-link" key={key}>
    <Anchor href={href} newTab>
      {text}
    </Anchor>
  </span>
);

const renderCommentWithMentions = (commentChunks) =>
  commentChunks.map((chunk) => {
    const { chunkId, text, isMention, mentionedUserId } = chunk;
    return isMention ? (
      <span key={chunkId} styleName="mention">
        <Anchor newTab href={`/users/${mentionedUserId}#contents`}>
          {text}
        </Anchor>
      </span>
    ) : (
      <Fragment key={chunkId}>{text}</Fragment>
    );
  });

const renderText = (text, mentionedUsers, commentsContext, parentId) => {
  // We only want to truncate parent comments when on the social feed widget
  if (commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED && !parentId) {
    return <Truncate text={text} />;
  }

  const commentChunks = createCommentChunkArray(text, mentionedUsers);
  return (
    <Linkify componentDecorator={componentDecorator}>
      <p styleName="comment-text">{renderCommentWithMentions(commentChunks)}</p>
    </Linkify>
  );
};

const CommentText = ({ text, mentionedUsers, parentId }) => {
  const commentsContext = useSelector(getCommentsContext, shallowEqual);
  return renderText(text, mentionedUsers, commentsContext, parentId);
};

CommentText.propTypes = {
  text: PropTypes.string.isRequired,
  mentionedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string,
      name: PropTypes.string
    })
  ),
  parentId: PropTypes.number
};

CommentText.defaultProps = {
  mentionedUsers: null,
  parentId: null
};

export default CommentText;
